import React from "react";
import { Button, ButtonGroup, createStyles, Grid, Theme } from "@material-ui/core";
import "../index.css";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    prevBtn: {
      backgroundColor: theme.palette.secondary.light,
      "&:hover": {
        backgroundColor: theme.palette.secondary.main,
      },
    },
  })
);

interface IProps {
  activeStep: number;
  lengthStepper: number;
  onClickNext: () => void;
  onClickPrev: () => void;
}

const Navigator: React.FC<IProps> = ({ activeStep, lengthStepper, onClickNext, onClickPrev }: IProps) => {
  const classes = useStyles();
  return (
    <div className="footer-navigator">
      <Grid container style={{ marginLeft: "15vw", width: "80%", padding: "0.5%" }} justify={"flex-start"}>
        <ButtonGroup fullWidth color={"primary"} variant={"contained"}>
          <Button onClick={activeStep === 0 ? () => {} : () => onClickPrev()} className={classes.prevBtn}>
            Wstecz
          </Button>
          <Button onClick={activeStep + 1 === lengthStepper ? () => {} : () => onClickNext()}>Dalej</Button>
        </ButtonGroup>
      </Grid>
    </div>
  );
};

export default Navigator;
